<template>
	<div>
		<input type="hidden" :value="tipofiltrado">
		<input type="hidden" :value="calcularValores">
		<section class="container-fluid">
			<div class="row mt-3">
				<div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                        <div class="mr-auto">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb clearfix pt-3">
                                    <li class="breadcrumb-item"><a href="#" @click="Menu">Regresar</a></li>
                                    <li class="breadcrumb-item active">Spend Plan Proyecto y Mantenimiento</li>
                                </ol>
                            </nav>
                        </div>
                        <div class="form-inline">
                            <div class="form-group mt-n1">
                                <!-- <button :disabled="PrintDisabled" @click="Descargar" type="button" class="btn btn-01 print mr-2"><i v-show="PrintDisabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Imprimir</button> -->
                                <button v-show="!VerSpendPlan" @click="Guardar" type="button" class="btn btn-01 save mr-2"><i v-show="Disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Guardar</button>
                            </div>
                        </div>
                    </nav>

                </div>
			</div>
			<div class="row justify-content-start mt-3">
				<div class="col-12 col-sm-12 col-md-12 col-lg-12">
					<div class="card card-01">
						<div class="row">
							<div class="col-md-12 col-lg-12">
								<div v-show="false" class="form-inline justify-content-start mt-2">
									<label class="mr-1">Servicio</label>
                                    <select @change="ListaSubTipo();" v-model="IdConfigS"   class="form-control form-control-sm mr-2">
                                        <option value="1">Mantenimiento</option>
										<option value="3">Proyecto</option>
                                        <option :value="6">Todos</option>
                                    </select>
									
									<label class="mr-1">Tipo Servicio</label>
                                    <select  @change="GetData();" v-model="IdTipoServ"    class="form-control form-control-sm mr-2">
                                        <option :value="''">Todos</option>
                                        <option v-for="(item, index) in ListaTipoServicio" :key="index" :value="item.IdTipoSer">{{item.Concepto}}</option>
                                    </select>

								</div>
								<hr v-show="false">
								<div class="form-inline justify-content-start mt-3">
									<div class="form-group mr-2">
										<label for="">Cliente</label>
									</div>
									<div class="form-group mr-2 text-left" style="max-width: 18rem">
										<treeselect
											disabled
											:options="ListaClientes"
											placeholder="Busque un Cliente..."
											v-model="Cliente.IdCliente"
											:disable-fuzzy-matching="true"
										/>
									</div>

									<div class="form-group mr-2">
										<label for="">Propiedad</label>
									</div>
									<div class="form-group mr-2" style="max-width: 18rem">
										<treeselect
											disabled
											:options="ListaPropiedades"
											placeholder="Busque una Propiedad..."
											v-model="Cliente.IdClienteS"
											:disable-fuzzy-matching="true"
										/>
									</div>

									<div class="form-group mr-2">
										<label for="">Contrato</label>
									</div>
									<div class="form-group mr-2" style="max-width: 23rem">
										<treeselect
											disabled
											:options="ListaContratos"
											placeholder="Busque un Contrato..."
											v-model="IdContrato"
											:disable-fuzzy-matching="true"
										/>
									</div>
									<label class="mr-2">Año</label>
                                    <select @change="GetData"  v-model="Anio" class="form-control form-control-sm mr-3 mb-1">
                                        <!-- <option value="">Todos</option> -->
										<option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
                                    </select>
									<div v-show="VerSpendPlan===false" class="form-check form-check-inline">
										<label class="check_box m-0 mt-2">
											<input checked id="eneradio1" v-model="OpcionLlenado" value="0" type="radio" class="form-check-input checkversion">
                                			<span class="checkmark"></span>
											<span class="bold" style="font-size:14px;top:3px">Lineal</span>
										</label>
									</div>
									<div v-show="VerSpendPlan===false" class="form-check form-check-inline">
										<label class="check_box m-0 mt-2">
											<input id="eneradio2" v-model="OpcionLlenado" value="1" type="radio" class="form-check-input checkversion">
                                			<span class="checkmark"></span>
											<span class="bold" style="font-size:14px;top:3px">Manual</span>
										</label>
									</div>
								</div>
								<hr>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-12 col-sm-12 col-md-12 col-lg-12">
								<div class="table-finanzas">
									<CLoader :pConfigLoad="ConfigLoad">
										<template slot="BodyFormLoad">
											<table class="table-fin-spendplan">
												<thead>
													<tr>
														<th></th>
														<th :style="index==(ListaHeaders.length-1) ? 'border-top:1px solid #000;border-right:1px solid #000' : index>0 ? 'border-top:1px solid #000' : 'border-top:1px solid #000;border-left:1px solid #000'" v-for="(item,index) in ListaHeaders" :key="index" class=" text-center medianaw-01" colspan="2">
															<div class="d-flex justify-content-center align-items-center">
																<div class="mr-2 bold">{{item}}</div>
															</div>
														</th>
													</tr>
													<tr>
														<th class="sticky mediana marca">Descripción</th>
														<th :style="index==(ListaHeaders.length-1) ? 'border-right:1px solid #000;background:#2E65B8' : index>0 ? 'background:#2E65B8' : 'border-left:1px solid #000;background:#2E65B8'" v-for="(item,index) in ListaHeaders" :key="index" class="text-center" colspan="2">
															<div class="d-flex">
																<div class="w-50">
																	Plan
																</div>
																<div class="w-50">
																	
																</div>
															</div>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="sticky borde_bajo"><b>Facturación</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;border-bottom:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold color-01'"  currency="$" separator="," :precision="2" v-model="item.FacturacionPMensual"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center color-01'"  currency="%" separator="," :precision="2" v-model="item.FacturacionPMensualPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Equipos</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Equipos"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.EquiposPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Materiales</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Materiales"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.MaterialesPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Mano De Obra</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.ManoDeObra"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.ManoDeObraPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Vehículos</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true|| item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Vehiculos"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.VehiculosPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Viaticos</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Viaticos"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.ViaticosPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky"><b>Burden</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Burden"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.BurdenPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="sticky borde_bajo"><b>Contratistas</b></td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;border-bottom:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda @input="CambiarMonto" :activo="VerSpendPlan===true || item.Permitir==0 || (item.PrimerMes!=1 && OpcionLlenado==0)" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.Contratistas"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.ContratistasPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="color-01 bold sticky marca borde_bajo">Costo Operacional</td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;border-bottom:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda :activo="true" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="item.CostoOp"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="item.CostoOpPorcen"/>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td class="color-01 bold sticky marca">Gross Profit</td>
														<td style="border-right:1px solid #000;border-left:1px solid #000;border-bottom:1px solid #000;" class="m-0 p-0" colspan="2" v-for="(item,index) in ListaDetalle" :key="index">
															<div class="d-flex">
																<div class="w-50">
																	<Cmoneda :activo="true" :minus="true" :clase="'ml-1 mt-1 mb-1 form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="item.GrossProfit"/>
																</div>
																<div class="w-50 ml-2" style="border-left:1px solid #000">
																	<Cporcentaje :activo="true" :minus="true" :clase="'mt-1 mb-1 form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="item.GrossProfitPorcen"/>
																</div>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</template>
									</CLoader>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
import CLoader from "@/components/CLoader";
export default {
	props:['Id','pVenta','pAccion','pOrigen'],
	components:{
        Cvalidation,
		CLoader
    },
	data() {
		return {
			errorvalidacion :[],
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			blockCampos:false,
			ListaClientes:[],
			ListaPropiedades:[],
			ListaAnios:[],
            ListaServicios:[],
			ListaTipoServicio:[],
			ListaContratos:[],
			ListaHeaders:[],
			ListaDetalle:[],
			OpcionLlenado:0, //0=lineal,1=Manual
			PrimerMes:[0,0,0,0,0,0,0,0,0,0,0,0],
			Cliente:{
				Nombre:'',
				IdCliente: null,
				IdClienteS: null,
			},
			IdContrato:null,
			IdConfigS:6,
			IdTipoServ:'',
			Anio:'',
			VerSpendPlan:true,
			IdVenta:'',
			FechaInicio:'',
			Origen:''
		}
	},
	methods: {
		Guardar(){
			this.Disabled=true;
			let formData=new FormData();
			formData.set('ListaDetalle',JSON.stringify(this.ListaDetalle));
			formData.set('IdVenta',this.IdVenta);
			this.$http.post('spendplanmantenimientoproyecto/post',formData).then((res)=>{
				this.$toast.success('Información Guardada Correctamente');
				this.$router.push({name:'crearspendplan'});
			});
		},
		GetData(){
			this.PrimerMes=[0,0,0,0,0,0,0,0,0,0,0,0];
			this.Disabled=false;
			this.ConfigLoad.ShowLoader=true;
			this.$http.get('spendplanmantenimientoproyecto/get',{
				params:{
					IdConfigS:this.IdConfigS,
					IdTipoServ:this.IdTipoServ,
					IdCliente:this.Cliente.IdCliente,
					IdClienteS:this.Cliente.IdClienteS,
					Anio:this.Anio,
					IdContrato:this.IdContrato,
					FechaInicio:this.FechaInicio,
				}
			}).then((res)=>{
				this.ListaDetalle=res.data.data.row;
				this.ListaHeaders=res.data.data.headers;
				let Contador=0;
				this.ListaDetalle.forEach((value) => {
					if (value.PrimerMes==1) {
						this.PrimerMes[Contador]=1;
					}
					Contador++;
				});
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		GetAnios(){
			this.Disabled=true;
			this.$http.get(
				'funciones/getanios',
				{
					params:{}
				}
			).then( (res) => {
				this.ListaAnios=res.data.ListaAnios;
				// this.Anio=res.data.AnioActual;
				// this.GetListaClientes();
				this.ListaSubTipo();
				// this.GetData();
			});
		},
		GetListaClientes(){
			this.$http.get("clientes/get"
			).then((res)=>{
				this.ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				});
				this.GetListaSucursales();
			});
		},
		GetListaSucursales(){
			// this.Cliente.IdClienteS=null;
			// this.IdContrato=null;
			this.$http.get("clientesucursal/get",{
				params:{
					Todos:true,
					RegEstatus:'A',
					IdCliente:this.Cliente.IdCliente
				}
			}
			).then((res)=>{
				this.ListaPropiedades=res.data.data.sucursal.map(function(obj){
					return {id:obj.IdClienteS,label:obj.Nombre}
				});
				this.GetListaNumContratos();
			});
		},
		GetListaNumContratos(){
			// this.IdContrato=null;
			this.$http.get("numcontrato/get",{
				params:{
					IdClienteS:this.Cliente.IdClienteS
				}
			}).then((res)=>{
				this.ListaContratos=res.data.data.contractlist.map(function(obj){
					return {id:obj.IdContrato,label:obj.NumeroC}
				})
				this.GetData();
			})
		},
		async ListaSubTipo() {
			if (this.IdConfigS>0)
			{
				await this.$http.get('tiposervicio/get',{
					params:{
						RegEstatus:'A',
						IdConfigS:this.IdConfigS,
						IdTipoServ:this.IdTipoServ,
						Entrada:''
					}
				}).then( (res) => {
					this.ListaTipoServicio =res.data.data.tiposervicio;
					// this.IdTipoServ="";
					this.GetListaClientes();
					// this.GetData();
				});
			}
		},
		Menu() {
			if (this.Origen=='proyecto') {
				this.$router.push({name:'proyectodesglose', params: {}});
			}
			else{
				this.$router.push({name:'crearspendplan', params: {}});
			}
		},
		CambiarMonto(){
			// console.log("a");
			let FacturacionPMensual=0;
			let Equipos=0;
			let Materiales=0;
			let ManoDeObra=0;
			let Vehiculos=0;
			let Viaticos=0;
			let Burden=0;
			let Contratistas=0;
			let UltimoIndex=-1;
			for (let index = 0; index < this.ListaDetalle.length; index++) {				
				if (this.ListaDetalle[index].Permitir==1) {
					UltimoIndex++;
				}
			}
			// console.log(UltimoIndex);
			if (UltimoIndex!=-1) {
				let Contador=0;
				let IndexPrimerMes=this.PrimerMes.findIndex((value) => value==1);
				if (IndexPrimerMes!=-1) {
					if (this.OpcionLlenado==0) {
						for (let index = IndexPrimerMes+1; Contador<UltimoIndex; index++) {
							FacturacionPMensual=this.ListaDetalle[IndexPrimerMes].FacturacionPMensual;
							this.ListaDetalle[index].FacturacionPMensual=FacturacionPMensual;
							Equipos=this.ListaDetalle[IndexPrimerMes].Equipos;
							this.ListaDetalle[index].Equipos=Equipos;
							Materiales=this.ListaDetalle[IndexPrimerMes].Materiales;
							this.ListaDetalle[index].Materiales=Materiales;
							ManoDeObra=this.ListaDetalle[IndexPrimerMes].ManoDeObra;
							this.ListaDetalle[index].ManoDeObra=ManoDeObra;
							Vehiculos=this.ListaDetalle[IndexPrimerMes].Vehiculos;
							this.ListaDetalle[index].Vehiculos=Vehiculos;
							Viaticos=this.ListaDetalle[IndexPrimerMes].Viaticos;
							this.ListaDetalle[index].Viaticos=Viaticos;
							Burden=this.ListaDetalle[IndexPrimerMes].Burden;
							this.ListaDetalle[index].Burden=Burden;
							Contratistas=this.ListaDetalle[IndexPrimerMes].Contratistas;
							this.ListaDetalle[index].Contratistas=Contratistas;
							Contador++;
						}
					}
				}
			}
		},
		getPorcent($monto,$montoDivisor){
			let PORCENTAJE_FINA = 0;

			if (parseFloat($monto)  > 0) {
				if (parseFloat($montoDivisor) > 0){
					let decimal = ( parseFloat($monto) / parseFloat($montoDivisor) );
					let porcenTemp= (decimal * 100);
					porcenTemp = porcenTemp.toFixed(2);
					PORCENTAJE_FINA = (porcenTemp > 100) ? 100 : porcenTemp;
				}
			}

			return PORCENTAJE_FINA;
		},
	},
	created() {
		if (this.pOrigen!=undefined) {
			localStorage.setItem('origenspend',this.pOrigen);	
		}
		this.Origen=localStorage.getItem('origenspend');
		this.GetAnios();
	},
	mounted() {
		this.IdConfigS=this.pVenta.IdConfigS;
		this.IdTipoServ=this.pVenta.IdTipoSer;
		this.Cliente.IdCliente=this.pVenta.IdCliente;
		this.Cliente.IdClienteS=this.pVenta.IdClienteS;
		this.IdContrato=this.pVenta.IdContrato;
		this.IdVenta=this.pVenta.IdVenta;
		this.FechaInicio=this.pVenta.FechaInicio;
		// console.log(this.pVenta.FechaInicio);
		this.Anio=new Date(this.FechaInicio).getFullYear();
		if (this.pAccion=='ver') {
			this.VerSpendPlan=true;
		}
		else{
			this.VerSpendPlan=false;
		}
		// console.log(this.pVenta);
	},
	computed:{
		tipofiltrado:function(){
			// if (this.Cliente.Nombre === '' && this.IdConfigS !== 6) {
			// 	this.blockCampos = true;
			// }
			// else if(this.IdContrato == '' && this.IdConfigS !== 6){
			// 	this.blockCampos = true;
			// }
			// else if(this.IdTipoServ == '' && this.IdConfigS !== 6){
			// 	this.blockCampos = true;
			// }
			// else if(this.Cliente.Nombre !== '' && this.IdContrato !== null && this.IdConfigS !== 6 && this.IdTipoServ!==''){
			// 	this.blockCampos = false;
			// }
			// if (this.IdContrato!==null) {
			// 	let IndexContrato=this.ListaNumc.findIndex((value) => value.IdContrato==this.IdContrato);
			// 	// console.log(this.ListaNumc[IndexContrato]);
			// 	if (IndexContrato!=-1) {
			// 		if (this.ListaNumc[IndexContrato].IdVenta!=null) {
			// 			this.blockCampos=true;
			// 		}
			// 	}	
			// }
			// return this.blockCampos;
		},
		calcularValores(){
			// console.log("a");
			for (let i = 0; i < this.ListaDetalle.length; i++) {
				let PlanFacturacion = 0;
				let CostoOpPlan = 0;
				// let GrossProfit=0;
				PlanFacturacion=this.ListaDetalle[i].FacturacionPMensual;
				if (isNaN(this.ListaDetalle[i].Equipos)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Equipos);
				}

				if (isNaN(this.ListaDetalle[i].Materiales)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Materiales);
				}

				if (isNaN(this.ListaDetalle[i].ManoDeObra)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].ManoDeObra);
				}

				if (isNaN(this.ListaDetalle[i].Vehiculos)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Vehiculos);
				}

				if (isNaN(this.ListaDetalle[i].Viaticos)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Viaticos);
				}

				if (isNaN(this.ListaDetalle[i].Burden)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Burden);
				}

				if (isNaN(this.ListaDetalle[i].Contratistas)) {
					CostoOpPlan += 0;
				}
				else{
					CostoOpPlan += parseFloat(this.ListaDetalle[i].Contratistas);
				}

				this.ListaDetalle[i].EquiposPorcen=this.getPorcent(this.ListaDetalle[i].Equipos,PlanFacturacion);
				this.ListaDetalle[i].MaterialesPorcen=this.getPorcent(this.ListaDetalle[i].Materiales,PlanFacturacion);
				this.ListaDetalle[i].ManoDeObraPorcen=this.getPorcent(this.ListaDetalle[i].ManoDeObra,PlanFacturacion);
				this.ListaDetalle[i].VehiculosPorcen=this.getPorcent(this.ListaDetalle[i].Vehiculos,PlanFacturacion);
				this.ListaDetalle[i].ViaticosPorcen=this.getPorcent(this.ListaDetalle[i].Viaticos,PlanFacturacion);
				this.ListaDetalle[i].BurdenPorcen=this.getPorcent(this.ListaDetalle[i].Burden,PlanFacturacion);
				this.ListaDetalle[i].ContratistasPorcen=this.getPorcent(this.ListaDetalle[i].Contratistas,PlanFacturacion);

				this.ListaDetalle[i].CostoOp=CostoOpPlan;
				this.ListaDetalle[i].CostoOpPorcen=this.getPorcent(CostoOpPlan,PlanFacturacion);
				this.ListaDetalle[i].GrossProfit=PlanFacturacion-CostoOpPlan;
				this.ListaDetalle[i].GrossProfitPorcen=this.getPorcent(this.ListaDetalle[i].GrossProfit,PlanFacturacion);
			}
		}
	}
}
</script>

<style>

</style>
